import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthProvider";
import api from '../api';


const PesertaProfile = () => {
  const { user } = useAuth();
  const apiUrl = process.env.REACT_APP_API_ENDPOINT;
  const [profile, setProfile] = useState(null);
  const [pembayaran, setPembayaran] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [error, setError] = useState(null);


  useEffect(() => {
    if (!user?.email) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setNotFound(false);
    setError(null);

    Promise.all([
      api.get(`${apiUrl}/api/peserta-profile?email=${encodeURIComponent(user.email)}`),
      api.get(`${apiUrl}/api/peserta-profile/pembayaran?username=${encodeURIComponent(user.email)}`),
    ])
      .then(([profileRes, pembayaranRes]) => {
        setProfile(profileRes.data);
        setPembayaran(pembayaranRes.data ?? []);
      })
      .catch((err) => {
        if (err.response?.status === 404) {
          setNotFound(true);
        } else {
          setError(err.response?.data?.message || "Gagal memuat profil peserta.");
        }
      })
      .finally(() => setLoading(false));
  }, [apiUrl, user]);

  if (loading) return <div className="container-xl mt-4">Loading...</div>;

  if (notFound) {
    return (
      <div className="container-xl mt-4">
        <div className="alert alert-warning">
          <h4 className="alert-heading">Profil peserta belum tersedia</h4>
          <p className="mb-0">
            Akun <strong>{user.email}</strong> belum terdaftar sebagai peserta di database lokal.
            Daftar atau gabung event melalui menu Info Event.
          </p>
          <Link to="/peserta/info-event" className="btn btn-primary mt-3">
            Ke Info Event
          </Link>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container-xl mt-4">
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }

  if (!profile) return null;

  return (
    <div className="container-xl mt-4">
      <div className="row">
        <div className="col-md-4">
          <div className="card card-body text-center">
            <h3 className="mb-0">{profile.namaLengkapGelar || profile.nama}</h3>
            <div className="text-muted">{profile.email}</div>
            <div className="mt-2">
              <span className="badge bg-blue-lt">{profile.nomorRegistrasi}</span>
            </div>
            <div className="mt-2">
              <span className="badge bg-green-lt">{profile.categoryEvent}</span>
            </div>
          </div>
        </div>
        <div className="col-md-8">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title mb-0">Data Peserta</h4>
            </div>
            <div className="card-body">
              <dl className="row">
                <dt className="col-sm-4">Nama</dt>
                <dd className="col-sm-8">{profile.namaLengkapGelar || profile.nama}</dd>

                <dt className="col-sm-4">NIK</dt>
                <dd className="col-sm-8">{profile.nik}</dd>

                <dt className="col-sm-4">Email</dt>
                <dd className="col-sm-8">{profile.email}</dd>

                <dt className="col-sm-4">No. HP</dt>
                <dd className="col-sm-8">{profile.hp}</dd>

                <dt className="col-sm-4">Event</dt>
                <dd className="col-sm-8">{profile.event?.eventCode} - {profile.event?.title}</dd>

                <dt className="col-sm-4">Audience Category</dt>
                <dd className="col-sm-8">{profile.audienceCategory?.namaCategory}</dd>

                <dt className="col-sm-4">Asal Institusi</dt>
                <dd className="col-sm-8">{profile.asalInstitusi}</dd>

                <dt className="col-sm-4">Workshop Sabtu</dt>
                <dd className="col-sm-8">{profile.workshopSabtu?.judul || "—"}</dd>

                <dt className="col-sm-4">Workshop Minggu</dt>
                <dd className="col-sm-8">{profile.workshopMinggu?.judul || "—"}</dd>

                <dt className="col-sm-4">Biaya Workshop</dt>
                <dd className="col-sm-8">
                  {profile.workshopBiaya != null
                    ? Number(profile.workshopBiaya).toLocaleString("id-ID", { style: "currency", currency: "IDR" })
                    : "—"}
                </dd>

                <dt className="col-sm-4">Total Biaya</dt>
                <dd className="col-sm-8">
                  {profile.totalBiaya != null
                    ? Number(profile.totalBiaya).toLocaleString("id-ID", { style: "currency", currency: "IDR" })
                    : "—"}
                </dd>
              </dl>
            </div>
          </div>

          <div className="card mt-4">
            <div className="card-header">
              <h4 className="card-title mb-0">Pembayaran</h4>
            </div>
            <div className="card-body">
              {pembayaran.length === 0 ? (
                <div className="text-muted">Belum ada data pembayaran.</div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Nomor Referensi</th>
                        <th>Bank</th>
                        <th>Atas Nama</th>
                        <th>Tgl Pembayaran</th>
                        <th>Status</th>
                        <th>Bukti</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pembayaran.map((bayar) => (
                        <tr key={bayar.id}>
                          <td>{bayar.nomorReferensi}</td>
                          <td>{bayar.bank}</td>
                          <td>{bayar.atasNama}</td>
                          <td>{bayar.tglPembayaran}</td>
                          <td>
                            <span className={`badge bg-${bayar.status === 'APPROVED' ? 'green' : bayar.status === 'REJECTED' ? 'red' : 'yellow'}`}>
                              {bayar.status}
                            </span>
                          </td>
                          <td>
                            <a href={`${apiUrl}/api/public/displayimage/${bayar.buktiPath}`} target="_blank" rel="noopener noreferrer">
                              Lihat Bukti
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PesertaProfile;
